import { ErrorOutline, Icon, Panel, Stack, Text } from '@/ui';
import { Inline } from '@/ui/layout/Inline';
import { toTitleCaseWords } from './errorStateTitle';
import {
  buildErrorStatePanelStackSx,
  ERROR_STATE_PANEL_BODY_SX,
  ERROR_STATE_PANEL_TITLE_ROW_SX,
  ERROR_STATE_PANEL_TITLE_SX,
} from './statePanelStyles';
import type { SxProps, Theme } from '@/ui/primitives/types';
import type { SvgIconComponent } from '@/ui/primitives/types';
import type { ReactElement, ReactNode } from 'react';

type ErrorStatePanelProps = {
  title: string;
  body?: ReactNode;
  actions?: ReactNode;
  icon?: SvgIconComponent;
  sx?: SxProps<Theme>;
};

export const ErrorStatePanel = ({
  title,
  body,
  actions,
  icon: StateIcon = ErrorOutline,
  sx,
}: ErrorStatePanelProps): ReactElement => (
  <Panel actions={actions} actionsAlign="center" sx={sx}>
    <Stack gap="sm" align="center" sx={buildErrorStatePanelStackSx()}>
      <Inline gap="sm" justify="center" wrap="nowrap" sx={ERROR_STATE_PANEL_TITLE_ROW_SX}>
        <Icon size="lg">
          <StateIcon color="error" aria-hidden="true" focusable="false" />
        </Icon>
        <Text role="sectionTitle" sx={ERROR_STATE_PANEL_TITLE_SX}>
          {toTitleCaseWords(title)}
        </Text>
      </Inline>
      {typeof body === 'string' ? (
        <Text role="bodyMuted" align="center" sx={ERROR_STATE_PANEL_BODY_SX}>
          {body}
        </Text>
      ) : (
        body
      )}
    </Stack>
  </Panel>
);
